import { FC } from 'react';

import { SelectForm, SelectFormProps } from './SelectForm';

export type dispatchTypeVariant = 'link' | 'phone' | 'email';

const DispatchTypeOptions = [
  { value: 'link', name: 'Link' },
  { value: 'phone', name: 'Phone' },
  { value: 'email', name: 'Email' },
] as const;

type DispatchTypeSelectFormProps = Omit<SelectFormProps<dispatchTypeVariant>, 'options'>;

export const DispatchTypeSelectForm: FC<DispatchTypeSelectFormProps> = (props) => {
  return <SelectForm {...props} options={DispatchTypeOptions} />;
};
